import { render } from "./GraphControls.vue?vue&type=template&id=7c9efbf6"
import script from "./GraphControls.vue?vue&type=script&lang=ts"
export * from "./GraphControls.vue?vue&type=script&lang=ts"
script.render = render

export default script